var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleHands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14",
    "data-name": "Group 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 396.047,
    height: 310.196,
    viewBox: "0 0 396.047 310.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 396.047,
    height: 310.196,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M935.07,568.895a14.217,14.217,0,1,1-14.217-14.217,14.217,14.217,0,0,1,14.217,14.217",
    transform: "translate(-614.595 -376.008)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 14.217,
    cy: 14.217,
    r: 14.217,
    transform: "translate(292.041 178.67)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M519.3,163.732c-6.051-3.2,1.509-8.6-3.659-12.893-4.8-3.983-10.732,2.867-14.052-2.815-5.516-9.442,24.078-25.085,33.258-16.347,9.336,8.886-7.173,36.486-15.548,32.056",
    transform: "translate(-339.561 -87.523)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M519.3,163.732c-6.051-3.2,1.509-8.6-3.659-12.893-4.8-3.983-10.732,2.867-14.052-2.815-5.516-9.442,24.078-25.085,33.258-16.347C544.187,140.562,527.678,168.161,519.3,163.732Z",
    transform: "translate(-339.561 -87.523)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 154.615,
    cy: 154.615,
    r: 154.615,
    transform: "translate(53.722 0.483)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 11.411,
    height: 70.301,
    transform: "translate(233.877 161.228) rotate(-81.213)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 11.411,
    height: 70.301,
    transform: "translate(233.877 161.228) rotate(-81.213)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M970.786,486.813l-29.029,7.512,1.743-11.278,29.029-7.512Z",
    transform: "translate(-638.403 -322.358)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M970.786,486.813l-29.029,7.512,1.743-11.278,29.029-7.512Z",
    transform: "translate(-638.403 -322.358)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M731.456,448.671l25.694-8.079,72.819,11.256L800.94,459.36Z",
    transform: "translate(-495.844 -298.67)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M731.456,448.671l25.694-8.079,72.819,11.256L800.94,459.36Z",
    transform: "translate(-495.844 -298.67)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M799.342,421.6l28.651-7.643-65.258-10.087-25.618,8.111Z",
    transform: "translate(-499.681 -273.78)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M799.342,421.6l28.651-7.643-65.258-10.087-25.618,8.111Z",
    transform: "translate(-499.681 -273.78)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M952.976,447.029l-28.787,7.622,1.83-11.84,28.788-7.622Z",
    transform: "translate(-626.494 -295.008)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M952.976,447.029l-28.787,7.622,1.83-11.84,28.788-7.622Z",
    transform: "translate(-626.494 -295.008)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 11.981,
    height: 62.964,
    transform: "translate(235.606 150.045) rotate(-81.213)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 11.981,
    height: 62.964,
    transform: "translate(235.606 150.045) rotate(-81.213)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M805.056,384.639,833.707,377l-65.258-10.087-25.618,8.112Z",
    transform: "translate(-503.554 -248.722)",
    fill: "#c0c1c0",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M805.056,384.639,833.707,377l-65.258-10.087-25.618,8.112Z",
    transform: "translate(-503.554 -248.722)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M958.69,410.065,929.9,417.687l1.83-11.84,28.788-7.622Z",
    transform: "translate(-630.367 -269.951)",
    fill: "#c0c1c0",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M958.69,410.065,929.9,417.687l1.83-11.84,28.788-7.622Z",
    transform: "translate(-630.367 -269.951)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 11.981,
    height: 62.964,
    transform: "translate(237.446 138.139) rotate(-81.213)",
    fill: "#c0c1c0",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 11.981,
    height: 62.964,
    transform: "translate(237.446 138.139) rotate(-81.213)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M1.5,204.928S66.487,234.039,71,240.642s-2.774,17.528-2.738,25.125c.032,6.837,4.57,13.207.644,15.985-4.285,3.033-45.416-7.864-66.517-12.442",
    transform: "translate(-1.017 -138.918)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M210.471,354.752s43.12,29.894,47.308,24.649-6.925-14.565-6.925-14.565,26.252,20.454,29.634,12.885-21.742-21.743-21.742-21.743,36.56,14.5,37.526,6.442-29.151-15.784-29.151-15.784,25.286,4.832,25.93-1.772-38.815-14.334-38.815-14.334,18.2-4.993,16.75-10.813-18.361-1.91-28.024-.5-30.987-2.174-30.987-2.174c2.948,6.455-1.607,15.179-2.831,22.073-.843,4.747.3,9.2,1.328,15.637",
    transform: "translate(-141.576 -214.632)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M210.471,354.752s43.12,29.894,47.308,24.649-6.925-14.565-6.925-14.565,26.252,20.454,29.634,12.885-21.742-21.743-21.742-21.743,36.56,14.5,37.526,6.442-29.151-15.784-29.151-15.784,25.286,4.832,25.93-1.772-38.815-14.334-38.815-14.334,18.2-4.993,16.75-10.813-18.361-1.91-28.024-.5-30.987-2.174-30.987-2.174c2.948,6.455-1.607,15.179-2.831,22.073C208.3,343.862,209.438,348.319,210.471,354.752Z",
    transform: "translate(-141.576 -214.632)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M279.75,385.963S286,389.945,295.3,380.04",
    transform: "translate(-189.638 -257.624)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M492.764,115.679c15.816-5.236,28.4-5.323,31.957.836,5.354,9.273-11.787,29.192-38.286,44.491s-52.32,20.184-57.674,10.911c-3.088-5.348,1.307-14.237,10.665-23.739",
    transform: "translate(-289.987 -75.801)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M568.832,158.125a4.53,4.53,0,1,1-4.53-4.53,4.53,4.53,0,0,1,4.53,4.53",
    transform: "translate(-379.462 -104.12)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M568.832,158.125a4.53,4.53,0,1,1-4.53-4.53A4.53,4.53,0,0,1,568.832,158.125Z",
    transform: "translate(-379.462 -104.12)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x1: 8.456,
    y2: 4.59,
    transform: "translate(155.911 67.787)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x1: 5.782,
    y2: 7.416,
    transform: "translate(164.367 71.847)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x1: 3.221,
    y2: 8.697,
    transform: "translate(172.302 76.208)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M571.976,348.415a25.194,25.194,0,1,1-22.947-27.256,25.194,25.194,0,0,1,22.947,27.256",
    transform: "translate(-353.638 -217.645)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M571.976,348.415a25.194,25.194,0,1,1-22.947-27.256A25.194,25.194,0,0,1,571.976,348.415Z",
    transform: "translate(-353.638 -217.645)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M271.367,522.2s10.151,7.589,10.438,8.573c.282.966-3.252,4.755-2.819,5.557.513.948,4.743.572,4.993,1.208.292.745-3.221,2.5-2.5,3.543s5.8,5.476,5.234,6.281-7.087,4.993-7.087,4.993",
    transform: "translate(-183.956 -353.994)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M694.674,290.945l-1.651,7.972s6.362-.684,7.328-.443-.242,3.785.483,4.349,3.942-1.53,4.668-1.208,0,5.879,0,5.879",
    transform: "translate(-469.79 -197.227)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M763.555,234.6s-15.6-.722-15.176,10.21c.282,7.3,14.483,3.556,14.857,6.04.665,4.409-12.23,4.2-14.042,4.5-1.193.2-.151,3.495.543,3.382.975-.158,20.2-.513,18.662-8.908-1.24-6.752-13.921-.846-14.1-5.5-.2-5.251,9.16-4.043,9.16-4.043Z",
    transform: "translate(-507.31 -159.028)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M763.555,234.6s-15.6-.722-15.176,10.21c.282,7.3,14.483,3.556,14.857,6.04.665,4.409-12.23,4.2-14.042,4.5-1.193.2-.151,3.495.543,3.382.975-.158,20.2-.513,18.662-8.908-1.24-6.752-13.921-.846-14.1-5.5-.2-5.251,9.16-4.043,9.16-4.043Z",
    transform: "translate(-507.31 -159.028)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x1: 2.476,
    y2: 31.527,
    transform: "translate(248.74 73.586)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x1: 2.26,
    y2: 31.527,
    transform: "translate(251.251 73.586)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M574.456,386.1s-.628-3.044.9-3.883,5.175.444,5.175.444-.459-3.6,1.59-4.875,5.055.434,5.055.434-.254-2.689,1.192-3.535,4.282,1.9,4.282,1.9",
    transform: "translate(-389.329 -253.882)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 3.198,
    y2: 3.234,
    transform: "translate(177.341 122.171)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x2: 2.208,
    y2: 4.877,
    transform: "translate(188.023 113.55)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x1: 0.455,
    y2: 5.296,
    transform: "translate(200.083 109.936)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M1012.26,33.446l-36.238,28.99,44.573,27.42,36.6-21.984",
    transform: "translate(-661.631 -22.672)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M888.069,128.951s-24.626,18.4-29.457,25.646-16.589,32.526-16.589,39.3c0,7.524,7.65,24.964,11.032,24.239s-1.691-21.26,0-25.125,9.663-13.368,14.012-11.878,1.208,20.414,7.006,20.978,5.073-18.763,7.248-22.87,3.624-2.4,4.59-9.986c.564-4.429,39.312-17.447,39.312-17.447Z",
    transform: "translate(-570.795 -87.414)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M888.069,128.951s-24.626,18.4-29.457,25.646-16.589,32.526-16.589,39.3c0,7.524,7.65,24.964,11.032,24.239s-1.691-21.26,0-25.125,9.663-13.368,14.012-11.878,1.208,20.414,7.006,20.978,5.073-18.763,7.248-22.87,3.624-2.4,4.59-9.986c.564-4.429,39.312-17.447,39.312-17.447Z",
    transform: "translate(-570.795 -87.414)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M875.394,326.708s16.175,14.954,18.344,11.762c1.409-2.074-12.482-18.381-15.5-24.43-2.242,3.24-4.191,4-2.845,12.667",
    transform: "translate(-593.117 -212.884)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M875.394,326.708s16.175,14.954,18.344,11.762c1.409-2.074-12.482-18.381-15.5-24.43C876,317.28,874.048,318.036,875.394,326.708Z",
    transform: "translate(-593.117 -212.884)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M885.157,302.235s13.2,21.591,16.236,18.046c1.35-1.578-11.185-14.454-10.648-23.657a73.679,73.679,0,0,0-5.587,5.61",
    transform: "translate(-600.035 -201.078)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M885.157,302.235s13.2,21.591,16.236,18.046c1.35-1.578-11.185-14.454-10.648-23.657A73.679,73.679,0,0,0,885.157,302.235Z",
    transform: "translate(-600.035 -201.078)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M910.664,297.62c.12,15.192,5.816,14.932,4.578,16.442-1.631,1.989-6.749-6.256-9.755-11.776-2.984-5.48-2.729-6.7-2.984-9.972,0,0,4.493-3.463,6.236-1.383,1.078,1.285,1.9,3.353,1.925,6.689",
    transform: "translate(-611.794 -196.767)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M910.664,297.62c.12,15.192,5.816,14.932,4.578,16.442-1.631,1.989-6.749-6.256-9.755-11.776-2.984-5.48-2.729-6.7-2.984-9.972,0,0,4.493-3.463,6.236-1.383C909.817,292.216,910.637,294.284,910.664,297.62Z",
    transform: "translate(-611.794 -196.767)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 15.059,
    cy: 15.059,
    r: 15.059,
    transform: "translate(154.651 184.366)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 10.666,
    cy: 10.666,
    r: 10.666,
    transform: "translate(156.879 207.355) rotate(-76.717)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 5.194,
    cy: 5.194,
    r: 5.194,
    transform: "translate(164.516 194.231)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 25.458,
    y2: 6.925,
    transform: "translate(144.359 192.657)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M446.706,588.786l-4.556,4.108-7.512-2,3.811-4.165-1.646-5.213,7.512,2Z",
    transform: "translate(-294.635 -394.202)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M346,646.939,334.9,659.06l-32.372,5.8,38.17,33.661,4.821-28.99L357.2,656.161Z",
    transform: "translate(-205.077 -438.55)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M346,646.939,334.9,659.06l-32.372,5.8,38.17,33.661,4.821-28.99L357.2,656.161Z",
    transform: "translate(-205.077 -438.55)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M316.909,699.732l31.443,27.541,2.577-18.924-15.12-12.222Z",
    transform: "translate(-214.828 -471.894)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M316.909,699.732l31.443,27.541,2.577-18.924-15.12-12.222Z",
    transform: "translate(-214.828 -471.894)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M348.774,718.319a20.554,20.554,0,0,1,7.328,5.556c2.9,3.7,7.328,3.7,8.456,5.073s.966,2.9,2.335,3.785",
    transform: "translate(-236.429 -486.938)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M387.4,723.069a4.231,4.231,0,0,1,2.134.805c.886.725.966,2.577,3.141,3.06",
    transform: "translate(-262.611 -490.158)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M469.584,803.157a8.637,8.637,0,1,1-8.637-8.637A8.636,8.636,0,0,1,469.584,803.157Z",
    transform: "translate(-306.615 -538.593)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M473.3,811.648a6.224,6.224,0,1,1-11.356,4.88",
    transform: "translate(-313.144 -550.204)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M490.205,805.647s-4.157-1.46-3.172-2.562C488.256,801.716,490.205,805.647,490.205,805.647Z",
    transform: "translate(-330.05 -544.203)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M459.9,818.055s-2-3.981-.256-4.15C461.2,813.754,459.9,818.055,459.9,818.055Z",
    transform: "translate(-311.105 -551.731)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x1: 2.819,
    y2: 4.268,
    transform: "translate(151.039 259.727)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x1: 2.496,
    y2: 4.041,
    transform: "translate(152.65 261.444)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x1: 2.496,
    y2: 4.041,
    transform: "translate(154.065 262.962)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x1: 0.403,
    y1: 2.941,
    transform: "translate(151.724 267.257)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x1: 1.166,
    y1: 2.548,
    transform: "translate(158.77 265.485)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M554.616,762.367c25.367-10.227,9.261-22.065,1.53-27.219s-8.7-12.079-8.7-12.079l-6.925,3.865s.826,7.852,6.362,12.643c5.578,4.828,19.407,12.244,6.523,20.778",
    transform: "translate(-366.413 -490.158)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M672.773,586.557H637.194l11.025-20.612H683.8Z",
    transform: "translate(-431.944 -383.646)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M666.951,557.344a4.087,4.087,0,1,1-4.087-4.086,4.087,4.087,0,0,1,4.087,4.086",
    transform: "translate(-446.575 -375.045)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M666.951,557.344a4.087,4.087,0,1,1-4.087-4.086A4.087,4.087,0,0,1,666.951,557.344Z",
    transform: "translate(-446.575 -375.045)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M775.814,554.4a5.488,5.488,0,1,1-5.488-5.487,5.487,5.487,0,0,1,5.488,5.487",
    transform: "translate(-518.473 -372.097)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 5.488,
    cy: 5.488,
    r: 5.488,
    transform: "translate(244.684 179.329) rotate(-22.5)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M631.723,619.513a4.953,4.953,0,1,1-4.953-4.953,4.953,4.953,0,0,1,4.953,4.953",
    transform: "translate(-421.521 -416.601)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 4.953,
    cy: 4.953,
    r: 4.953,
    transform: "translate(200.297 197.959)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M742.215,618.623a5.375,5.375,0,1,1-5.375-5.375,5.375,5.375,0,0,1,5.375,5.375",
    transform: "translate(-495.849 -415.712)",
    fill: "#c0c1c0",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M742.215,618.623a5.375,5.375,0,1,1-5.375-5.375A5.375,5.375,0,0,1,742.215,618.623Z",
    transform: "translate(-495.849 -415.712)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 23.227,
    height: 5.34,
    transform: "translate(196.908 160.702) rotate(-27.692)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 23.227,
    height: 5.34,
    transform: "translate(196.908 160.702) rotate(-27.692)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 23.227,
    height: 5.34,
    transform: "translate(199.39 165.43) rotate(-27.692)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 23.227,
    height: 5.34,
    transform: "translate(199.39 165.43) rotate(-27.692)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 14.733,
    height: 5.34,
    transform: "translate(205.704 168.322) rotate(-27.692)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 14.733,
    height: 5.34,
    transform: "translate(205.704 168.322) rotate(-27.692)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M948.79,153.258c-3.327,3.859,8.757,21.622,23.413,25.145",
    transform: "translate(-642.794 -103.891)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M941.331,159.07c-5.013,2.718,12.295,26.882,21.682,25",
    transform: "translate(-637.509 -107.831)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M964.13,138.165c-2.45-.242-3.662,2.617,2.3,8.979",
    transform: "translate(-652.202 -93.651)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M1009.272,198.459s6.3,6.156,12.607,6.478",
    transform: "translate(-684.171 -134.532)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M976.506,168.094a2.023,2.023,0,1,1-2.023-2.023,2.023,2.023,0,0,1,2.023,2.023",
    transform: "translate(-659.216 -112.577)",
    fill: "#231f20",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 2.023,
    cy: 2.023,
    r: 2.023,
    transform: "matrix(0.924, -0.383, 0.383, 0.924, 312.623, 54.422)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M1006.319,194.2a2.023,2.023,0,1,1-2.023-2.023,2.023,2.023,0,0,1,2.023,2.023",
    transform: "translate(-679.426 -130.275)",
    fill: "#231f20",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 2.023,
    cy: 2.023,
    r: 2.023,
    transform: "matrix(0.924, -0.383, 0.383, 0.924, 322.227, 62.832)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M937.755,573.7a11.786,11.786,0,1,1-11.786-11.786A11.786,11.786,0,0,1,937.755,573.7",
    transform: "translate(-619.711 -380.916)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 11.786,
    cy: 11.786,
    r: 11.786,
    transform: "translate(290.859 199.166) rotate(-67.5)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M938.708,595.78l1.06-4.133-2.174-3.382-2.979,1.127-1.691-2.255s-1.45,0-1.611-.4.886-1.936.644-2.78-1.772-.522-1.691-1.73a9.654,9.654,0,0,1,.644-3.089c.773-1.758,3.785-2.709,7.65-.7s5.879,10.445,5.879,10.445l-1.933,5.375",
    transform: "translate(-630.611 -391.349)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M938.708,595.78l1.06-4.133-2.174-3.382-2.979,1.127-1.691-2.255s-1.45,0-1.611-.4.886-1.936.644-2.78-1.772-.522-1.691-1.73a9.654,9.654,0,0,1,.644-3.089c.773-1.758,3.785-2.709,7.65-.7s5.879,10.445,5.879,10.445l-1.933,5.375",
    transform: "translate(-630.611 -391.349)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M938.085,571.7c-1.169-.263-3.479,1.325-4.53,1.57-1.236.289-1.027,3.02,1.148,3.141s3.422-.423,3.885.422-.285,3.3.482,3.582,1.672-1.166,2.276-.925.48,1.5,1.691.826,2.722-6.417,0-7.65c-1.288-.584-1.691.2-2.657.121s-1.49-.906-2.3-1.087",
    transform: "translate(-632.331 -387.524)",
    fill: "#231f20",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M938.085,571.7c-1.169-.263-3.479,1.325-4.53,1.57-1.236.289-1.027,3.02,1.148,3.141s3.422-.423,3.885.422-.285,3.3.482,3.582,1.672-1.166,2.276-.925.48,1.5,1.691.826,2.722-6.417,0-7.65c-1.288-.584-1.691.2-2.657.121S938.891,571.876,938.085,571.7Z",
    transform: "translate(-632.331 -387.524)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    y1: 0.74,
    x2: 1.807,
    transform: "translate(306.982 196.175)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    y1: 0.74,
    x2: 1.807,
    transform: "translate(306.982 196.175)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    y1: 3.952,
    x2: 1.258,
    transform: "translate(305.724 200.478)",
    fill: "#231f20",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    y1: 3.952,
    x2: 1.258,
    transform: "translate(305.724 200.478)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    y1: 3.762,
    x2: 1.288,
    transform: "translate(313.827 193.774)",
    fill: "#231f20",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    y1: 3.762,
    x2: 1.288,
    transform: "translate(313.827 193.774)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M742.391,758.784s-43-55.2-47.834-58.947-31.593-25.729-25.85-33.1c5.486-7.038,21.491,12.822,30.421,17.394,7.119,3.645,14.532-.6,30.016-11.072,11.6-7.844,15.009-9.865,17.072-7.221,3.624,4.644-11.67,10.313-10.63,20.991,1.483,15.236,45.579,47.109,45.579,47.109",
    transform: "translate(-452.762 -450.619)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M742.391,758.784s-43-55.2-47.834-58.947-31.593-25.729-25.85-33.1c5.486-7.038,21.491,12.822,30.421,17.394,7.119,3.645,14.532-.6,30.016-11.072,11.6-7.844,15.009-9.865,17.072-7.221,3.624,4.644-11.67,10.313-10.63,20.991,1.483,15.236,45.579,47.109,45.579,47.109",
    transform: "translate(-452.762 -450.619)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M765.461,708.663s-12-28.4-6.234-31.567c5.536-3.04,25.93,25.367,27.058,49",
    transform: "translate(-513.608 -458.841)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M765.461,708.663s-12-28.4-6.234-31.567c5.536-3.04,25.93,25.367,27.058,49",
    transform: "translate(-513.608 -458.841)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M844.858,838.575s20.521-15.008,30.828-23.3l10.936,9.439s-22.161,19.882-30.927,27.615Z",
    transform: "translate(-572.717 -552.662)",
    fill: "#c0c1c0",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M844.858,838.575s20.521-15.008,30.828-23.3l10.936,9.439s-22.161,19.882-30.927,27.615Z",
    transform: "translate(-572.717 -552.662)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M796.626,649.6c2.313-15.2,6.382-21.745,10.365-29.681,2.267-4.517,1.487-13.6-4.155-10.83-11.879,5.833-16.053,26.2-16.053,26.2Z",
    transform: "translate(-533.348 -412.541)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M796.626,649.6c2.313-15.2,6.382-21.745,10.365-29.681,2.267-4.517,1.487-13.6-4.155-10.83-11.879,5.833-16.053,26.2-16.053,26.2Z",
    transform: "translate(-533.348 -412.541)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M817.341,666.6c.542-10.265,11.881-36.779,15.359-32.483,4.107,5.073-7.368,28.941-7.368,28.941",
    transform: "translate(-554.063 -429.54)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M817.341,666.6c.542-10.265,11.881-36.779,15.359-32.483,4.107,5.073-7.368,28.941-7.368,28.941",
    transform: "translate(-554.063 -429.54)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M835.981,887.224l10.951,13.884-2.775,2.2a3.865,3.865,0,0,1-5.43-.625l-6.146-7.829a3.865,3.865,0,0,1,.625-5.43Z",
    transform: "translate(-563.827 -601.436)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M835.981,887.224l10.951,13.884-2.775,2.2a3.865,3.865,0,0,1-5.43-.625l-6.146-7.829a3.865,3.865,0,0,1,.625-5.43Z",
    transform: "translate(-563.827 -601.436)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M831.744,725.24s5.61-3.857,10.116-2.657",
    transform: "translate(-563.827 -489.671)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M831.744,725.24s5.61-3.857,10.116-2.657",
    transform: "translate(-563.827 -489.671)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x2: 8.516,
    y2: 7.838,
    transform: "translate(188.749 136.157)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 1.78,
    y2: 11.436,
    transform: "translate(203.949 128.189)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleHands);
export default __webpack_public_path__ + "static/media/circle_hands.157032f6c5c67b7930dabdc76dbd82f7.svg";
export { ForwardRef as ReactComponent };